import useLocale from 'next-translate/useTranslation';
import React from 'react';

import PrimaryLink from './links/PrimaryLink';

const Faq = () => {
  const { t } = useLocale('home');

  return (
    <section id='faq' className='bg-gray-100 dark:bg-slate-800'>
      <div className='container mx-auto flex flex-col justify-center p-4  md:p-8'>
        <p className='p-2 text-center text-sm font-medium uppercase tracking-wider dark:text-slate-200'>
          {t('If you have any questions, please')}{' '}
          <PrimaryLink href='/contact' target='_blank'>
            {t('contact us')}
          </PrimaryLink>
        </p>
        <h2 className='mt-2 mb-12 text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          {t('Frequently Asked Questions')}
        </h2>
        <div className='grid gap-10 sm:p-3 md:grid-cols-2 md:gap-8 lg:px-12 xl:px-32'>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Can I change my plan at any time?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t('Yes, you can upgrade or downgrade your plan at any time.')}
            </p>
          </div>
          {/* <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              Is there a free trial?{' '}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              Yes, we offer a 7-day free trial so you can try out our services
              before you commit.
            </p>
          </div> */}
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Is there a discount for annual subscriptions?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t('Yes, we offer a 40% discount if you choose the annual plan.')}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('When will I be billed?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t('You will be billed at the start of your subscription.')}
            </p>
          </div>
          {/* <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Is there a money-back guarantee?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                "If you don't find Easy-Peasy.AI meets your needs, we guarantee a full refund of your payment within 30 days of purchase—no questions asked."
              )}
            </p>
          </div> */}
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Are there any hidden fees?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'No, there are no hidden fees. You just pay the monthly subscription fee.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('How do I cancel my subscription?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'You can easily cancel your subscription at any time by going to your account settings.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Do you offer any kind of support?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Yes, we offer email and live chat support for all of our customers.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('What payment methods are accepted?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'We support all major credit cards and debit cards. Your payment method is secured by Stripe for your privacy and security. For PayPal payments, please contact us.',
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
